<template>
  <component
    :is="itemComponent"
    :href="url"
    :class="{
      'is-active': item.isActive
    }"
    @click="$emit('click', $event)"
  >
    <slot name="prefix" />
    <span>
      {{ item.name }}
      <span
        v-if="item.showNewLabel"
        class="c-splash-sign c-splash-sign--large"
      >
        <span>{{ newLabel }}</span>
      </span>
    </span>
    <slot />
  </component>
</template>

<script>

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    newLabel: {
      type: String,
      default: null
    }
  },
  computed: {
    itemComponent() {
      return this.item.showAsText ? 'span' : 'a'
    },
    url() {
      return this.item.showAsText ? null : this.item.url
    }
  }
}

</script>
